export default {
  restaurantbenefits: {
    subtitle: "للمطاعم",

    title1: "لماذا تختار المطاعم",
    title2: "MAHAL",

    desc:
      "تساعد MAHAL المطاعم على إدارة التوريد الغذائي بكفاءة من خلال موردين موثوقين وأسعار عادلة وتوصيل موثوق.",

    items: {
      1: {
        icon: "fas fa-seedling",
        title: "مكونات طازجة وعالية الجودة",
        desc: "احصل على الخضروات والفواكه واللحوم من موردين موثوقين.",
      },
      2: {
        icon: "fas fa-tags",
        title: "أسعار شفافة",
        desc: "قارن الأسعار بسهولة بدون تكاليف مخفية.",
      },
      3: {
        icon: "fas fa-clock",
        title: "وفر الوقت والجهد",
        desc: "إدارة جميع الطلبات اليومية والكبيرة من منصة واحدة.",
      },
      4: {
        icon: "fas fa-truck",
        title: "توصيل يومي موثوق",
        desc: "استلم طلباتك في الوقت المناسب للحفاظ على سير العمل.",
      },
      5: {
        icon: "fas fa-boxes-stacked",
        title: "طلبات بالجملة ومتكررة",
        desc: "قم بجدولة الطلبات بسهولة.",
      },
      6: {
        icon: "fas fa-mobile-screen",
        title: "طلب سهل عبر التطبيق",
        desc: "اطلب وتتبع الطلبات في الوقت الحقيقي.",
      },
    },

    cta: "ابدأ الطلب لمطعمك",
  },
};